(ns frontend.ux-overhaul.nev.components.nev-header
  (:require
   [ui.util :as uu]
   [reagent.core :as r]
   [frontend.utils :as fu]
   [re-frame.core :as rf]
   [frontend.routing :as routing]
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.view.components.new-tags.view :as new-tags]
   [clojure.set :as set]
   [common.schema.registry :as registry]
   [potpuri.core :as p :refer [fn-> fn->> index-by]]
   [frontend.actions.entity :as entity-actions]
   [frontend.logging :as logging]
   [common.util :as cu :refer [flip only-entity]]
   [common.entity :as entity]
   [common.attribute :as attribute]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.curtains.tag-curtain.view :as tag-curtain]
   [frontend.state.permissions :as f-permissions]
   [frontend.ux-overhaul.nev.utils :as nev-utils]
   [frontend.ux-overhaul.nev.events :as nev-events]
   [frontend.ux-overhaul.nev.sub :as nev-sub]
   [frontend.ux-overhaul.modal.save-view.view :as save-view-modal]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [frontend.ux-overhaul.nev.interim.edit-oppo-name-modal :as edit-oppo-name-modal]
   [ui.components.button.view :as button]))

(defn new-zapflow-toggle
  []
  (let []
    (fn []
      (let [edit-value @nev-sub/new-nev-in-use?]
        [:div.new-nev-toggle
         {:style {:margin    "0px 20px"
                  :width     "80px"
                  :min-width "80px"}}
         [:label
          {:for   :new-zapflow-toggle
           :style {:margin-right "0px"
                   :font-size    "12px"}}

          "New Zapflow"]
         [:div
          {:class-name (fu/cs "component-toggle")}


          [:label
           {:class-name (fu/cs "component-toggle__background"
                               (when edit-value "checked"))}
           [:input
            (merge {:type        "checkbox"
                    :id          :new-zapflow-toggle
                    :checked     edit-value
                    :value       edit-value
                    :class-name  (fu/cs "component-toggle__checkbox")
                    :on-focus    (fn [e])
                    :on-blur     (fn [e])
                    :on-key-down (fn [])
                    :on-change   (fn [e]
                                   (let [checked? (-> e
                                                      .-target
                                                      .-checked)]
                                     (nev-events/set-new-nev-enabled! checked?)))})]
           [:span.component-toggle__dot]
           [:span.component-toggle__text
            ""]]
          [:div.component-toggle__remaining-space]]]))))


(defn nev-dropdown
  [{:keys [state label search-renderer actions custom-items-renderer
           dropdown-toggle dropdown-toggle-class-name]}]
  (let [actions (if (fn? actions)
                  (actions state)
                  actions)
        max-ord (->> actions
                     (keep :ord)
                     (apply max 0))
        actions (->> actions
                     (map-indexed (fn [idx {:keys [ord] :as ta}]
                                    (assoc ta
                                           :ord
                                           (or ord
                                               (+ idx max-ord 1))))))

        dropdown-actions (->> actions
                              (filter :dropdown-action?)
                              (sort-by :ord))
        force-dropdown-visible? (->> actions
                                     (some (fn [a]
                                             (and (not (:toolbar-button? a))
                                                  (:dropdown-action? a)
                                                  (not (:divider a))))))]
    (when-not (empty? dropdown-actions)
      [dropdown-menu/view
       {:trigger [dropdown-menu/button-trigger-open
                  [:i.fas.fa-ellipsis-v]]
        :items   (->> dropdown-actions
                      (map-indexed
                       (fn [idx action]
                         (let [{:keys [label icon ord tooltip-text dropdown-color divider divider?
                                       on-select disabled? toggle-item? checked? on-checked-change]}
                               action]
                           {:label          label
                            :icon-class     (uu/cm "fal" icon)
                            :separator?     divider?
                            :disabled?      (boolean disabled?)
                            :section-label? (true? divider)
                            :on-click       on-select})))
                      (doall))}])))

(defn tags-view
  [{:keys [entity-type entity-id asset-id edit-entity-id edit-entity-type icon title pipeline-id]
    :as   view-args}]
  (let [session-entities @session/entities
        tenant-schema @session/tenant-schema
        entity (get session-entities entity-id)
        add-tags-text (loc/tr :add-entity-tags [(loc/tr entity-type)])
        attribute-schemas (->> (f-permissions/available-tag-attribute-schemas entity-type
                                                                              pipeline-id)
                               (sort-by (fn [a]
                                          (some->> a
                                                   (first)
                                                   (attribute/attribute-label tenant-schema)))))
        attributes (->> attribute-schemas
                        (map first))
        tags (->> attributes
                  (mapcat (fn [a]
                            (let [tags (get entity a)
                                  tag-ids (cond (nil? tags)
                                                nil
                                                (coll? tags)
                                                tags
                                                (number? tags)
                                                [tags])]
                              (->> tag-ids
                                   (map (fn [val]
                                          [a (get session-entities val)])))))))
        writable-tag-attributes
        (->> attribute-schemas
             (filter
              (fn [[attribute fs]]
                (f-permissions/field-write-access? attribute (:entity/type entity) pipeline-id))))]
    [:div
     [:div.new-tags-list-container
      (when (or (seq writable-tag-attributes)
                (seq tags))
        #_[:i
           {:class-name (fu/cs "i fal new-tags-icon"
                               (or icon
                                   (entity/default-icon entity)))
            :on-click   (fn [_]
                          (when (seq writable-tag-attributes)
                            (modals/open-modal!
                             tag-curtain/modal-key
                             {:entity-id   edit-entity-id
                              :entity-type edit-entity-type
                              :header-text title
                              :pipeline-id pipeline-id
                              :asset-id    asset-id})))}])
      [:div
       {:class-name (fu/cs "new-tag-container-wrapper"
                           (when (empty? tags)
                             "tags-empty"))}
       (doall
        (for [[index tag] (map-indexed vector tags)]
          ^{:key (str tag index)}
          [new-tags/tag-element
           {:tag         tag
            :pipeline-id pipeline-id
            :entity      entity}]))]
      (when-not (empty? writable-tag-attributes)
        [button/secondary-open 
         {:tooltip add-tags-text}
         [:i
          {:class-name (fu/cs "fal fa-pencil"
                              #_"new-tags-open-editor-button")
           :on-click   (fn [_]
                         (modals/open-modal!
                          tag-curtain/modal-key
                          {:entity-id   edit-entity-id
                           :pipeline-id pipeline-id
                           :entity-type edit-entity-type
                           :header-text title
                           :asset-id    asset-id}))}]])]]))





(defn name-tags-and-stuff
  [view-args]
  (let [state-atom (r/atom {:hover? false
                            :focus? false})]
    (fn [view-args external-state-atom]
      (let [{:keys [oppo-id]} view-args

            entity @(r/track session/get-entity oppo-id)

            {:keys [hover? focus? deal-name-hover?]} @state-atom
            show-edit-view-btn? false
            #_(or hover? focus?)]
        [:div
         {:on-mouse-enter #(swap! state-atom assoc :hover? true)
          :on-mouse-leave #(swap! state-atom dissoc :hover?)
          :style          {:display         "flex"
                           :justify-content "space-between"
                           :align-items     "center"
                           :height          "100%"
                           :max-width       "100%"
                           :overflow-x      "scroll"}}

         [:div
          {:style {:display     "flex"
                   :height      "100%"
                   :width       "100%"
                   :gap         "20px"
                   :align-items "end"}}
          [:div
           {:on-mouse-enter #(swap! state-atom assoc :deal-name-hover? true)
            :on-mouse-leave #(swap! state-atom assoc :deal-name-hover? false)
            :style          {:margin-bottom "10px"
                             :white-space   "nowrap"
                             :cursor        "default"}}
           [:p "Deal"]
           [:div
            {:style {:display       "flex"
                     :align-items   "center"
                     :padding-right "25px"
                     :position      "relative"}}
            [:p
             {:style {:font-size "20px"}}
             (:oppo/name entity)]
            (when deal-name-hover?
              [:i.fal.fa-edit
               {:on-click (fn []
                            (modals/open-modal!
                             edit-oppo-name-modal/modal-key
                             {:label         "Edit Deal Name"
                              :accounts      []
                              :value         (:oppo/name entity)
                              :set-edit!     identity
                              :show-buttons? true
                              :on-change!    (fn [_])
                              :close-modal!  (fn []
                                               (js/console.log "close modal"))

                              :on-submit!    (fn [new-name]
                                               (js/console.log "new name " new-name)

                                               (entity-actions/*->field-update!
                                                (:db/id entity)
                                                :oppo/name
                                                new-name
                                                (fn [res]
                                                  (js/console.log "success " res))
                                                (fn [err]
                                                  ;;retract the optimistic save above
                                                  (js/console.log "error " err))))}))
                :style    {:color    "#8ABF4C"
                           :cursor   "pointer"
                           :position "absolute"
                           :right    "0px"}}])]]

          [:div
           {:style {:display       "flex"
                    :flex-grow     "2"
                    :overflow-x    "scroll"
                    :margin-bottom "8px"}}
           [:div.tags-container.mr-3
            [:p.tag-label "Deal tags"]
            [tags-view
             {:entity-id        (:db/id entity)
              :entity-type      (:entity/type entity)
              :edit-entity-id   (:db/id entity)
              :edit-entity-type (:entity/type entity)
              :pipeline-id      (:oppo/pipeline entity)
              :icon             :fa-tags
              :title            (loc/tr :-tags [(loc/tr (:entity/type entity))])}]]

           (when-let [related-tags-entity @(r/track session/get-entity (:oppo/target-asset entity))]
             [:div.tags-container
              [:p.tag-label (str (loc/tr (:entity/type related-tags-entity)) " tags")]
              [tags-view
               {:entity-id        (:db/id related-tags-entity)
                :entity-type      (:entity/type related-tags-entity)
                :edit-entity-id   (:db/id related-tags-entity)
                :pipeline-id      (:oppo/pipeline entity)
                :edit-entity-type (:entity/type related-tags-entity)
                :title            (loc/tr :-tags [(loc/tr (:entity/type related-tags-entity))])}]])]

          [:div]]

         [:div
          (when show-edit-view-btn?
            [fu/tooltip-overlay
             {:id        "toggle-sidebar"
              :placement "left"}
             "Edit view"
             [:span
              {:style    {:cursor "pointer"}
               :on-click (fn [e]
                           (swap! external-state-atom assoc :save-view-modal? true)
                           #_(rf/dispatch [::nev-events/open-view-configuration (routing/view)]))}
              [:i.fa.fa-pencil]]])]]))))


(defn view
  [header-args view-args]
  (let [state-atom (r/atom {:save-view-modal? false})]
    (fn []
      (let [{:keys [save-view-modal?]} @state-atom]
        [:div.new-nev-container
         {:style {:height      "70px"
                  :position    "relative"
                  :z-index     "10"
                  :display     "flex"
                  :background  "white"
                  :align-items "end"
                  :padding     "0px"}}
         [:div
          {:style {:margin      "0px 20px 0px 0px"
                   :height      "100%"
                   :display     "flex"
                   :align-items "center"}}
          [:div
           [:button.btn.btn-link.back-btn.nev-back-btn
            {:on-click #(routing/set-view! [:oppos-grid])
             :style    {:display     "flex"
                        :align-items "center"
                        :color       "#8ABF4C"}}
            [:i.fas.fa-angle-left.mr-1.mt-1]
            [:span.btn-text
             {:style {:text-decoration "underline"}}
             "Deals"]]]]

         [:div
          {:style {:flex-grow  "2"
                   :height     "100%"
                   :overflow-x "hidden"}}
          [name-tags-and-stuff view-args state-atom]]

         [:div
          {:style {:height      "100%"
                   :display     "flex"
                   :align-items "center"}}
          [new-zapflow-toggle]
          [:div
           {:style {:margin-right "20px"}}
           [nev-dropdown header-args]]]

         (when save-view-modal?
           [save-view-modal/view {:close-modal! #(swap! state-atom dissoc :save-view-modal?)}])]))))
